import { render, staticRenderFns } from "./OP_CPTSummary.vue?vue&type=template&id=55cede4c&scoped=true&"
import script from "./OP_CPTSummary.vue?vue&type=script&lang=js&"
export * from "./OP_CPTSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cede4c",
  null
  
)

export default component.exports